<template>
<!--      v-hammer:swipe.horizontal="event => setImportant(event)"-->
  <li class="list-item"
      :class="{checked, editing, important}"
      v-show="!(checked && !checkedItemsVisible) || editing || currentQuery"
  >
    <div class="row">
      <div class="row grow">
        <input class="checkbox"
               type="checkbox"
               v-model="checked"
               :id="item.id"
               @input="closeAppMenu"
               v-if="!editing"
               v-long-press="toggleImportant"
        >
        <div class="handle" v-else />
        <label class="name" :for="item.id">
          <input type="text" class="input-bg" v-model="name" v-if="editing">
          <span v-text="name" v-else/>
        </label>
      </div>
      <div class="row actions">
        <count-buttons v-model="count" v-show="!editing && !checked"/>
        <button class="bare" @click="deleting = true" v-if="!deleting && editing" ref="pre-delete">⨉</button>
        <button class="destructive" @click="deleteListItem(item.id)" v-if="deleting" ref="delete">⨉</button>
      </div>
    </div>
  </li>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import CountButtons from '@/components/CountButtons'

  export default {
    name: "ListItem",
    components: {CountButtons},
    props: {
      item: {
        type: Object,
        required: true
      },
    },
    data () {
      return {
        deleting: false
      }
    },
    methods: {
      ...mapActions(['setListItemChecked', 'setListItemCount', 'setListItemName', 'deleteListItem', 'closeAppMenu', 'setListItemImportant']),
      toggleImportant () {
        this.setListItemImportant({id: this.item.id, force: !this.important})
      },
      setImportant (event) {
        console.log(event)
        this.setListItemImportant({id: this.item.id, force: event.deltaX < 0})
      },
    },
    computed: {
      ...mapState(['checkedItemsVisible', 'editing', 'currentQuery']),
      checked: {
        get () {
          return this.item.checked
        },
        set (val) {
          this.setListItemChecked({id: this.item.id, checked: val})
        }
      },
      count: {
        get () {
          return this.item.count
        },
        set (val) {
          this.setListItemCount({id: this.item.id, count: val})
        }
      },
      name: {
        get () { return this.item.name },
        set (val) { this.setListItemName({id: this.item.id, name: val}) }
      },
      important: {
        get () { return this.item.important }
      }
    },
    mounted () {
      const setNotDeleting = event => {
        if (event.target !== this.$refs['pre-delete'] && event.target !== this.$refs['delete'])
          this.deleting = false
      }

      window.addEventListener('click', setNotDeleting)
      window.addEventListener('touchmove', setNotDeleting)
    }
  }
</script>

<style scoped lang="sass">
  .list-item
    display: block
    border-bottom: solid 1gem $gray-bg
    padding: $size-6 0
    background-color: $white
    transition: $transition-quick
    user-select: none
    -webkit-user-select: none
    /*touch-action: none*/

    +dark
      background-color: $black-5
      border-color: $black-10
      border-width: 0
      border-radius: $item-radius
      margin: 4gem 0
      padding-left: 6gem

    &.editing
      border-color: transparent

    &.important
      +dark
        background-color: $blue-dark

      .name
        color: $black

        +dark
          color: $white

      .checkbox
        &:after
          content: '!'

    > .row
      min-height: $size-36

  .name
    flex: 1
    margin-left: $size-18
    transition: $transition-quick
    color: $gray-dark

    +dark
      color: $gray

    .checked:not(.editing) &
      opacity: .25

    input, span
      padding: .25em .5em
      border-width: 1gem
      display: inline-block
      border-style: solid

    span
      border-color: transparent

  .row.actions
    flex-shrink: 0

  .drag-item
    opacity: 1
    box-shadow: 0 0 16gem rgba(0,0,0,.15)
    border-radius: $item-radius
    right: 0

    input
      background-color: transparent
</style>
